
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "http://localhost:7999";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-cleaning.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-cleaning.m2msystems.cloud";
    }
    return __root
}

/**
 * @deprecated 清掃員が自身に紐づく清掃の一覧を取得する
 * 
 */
export const listMyCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listMyCleanings.method = "GET" as const;

/**
 * @deprecated 清掃員が自身に紐づく共用部清掃の一覧を取得する
 * 
 */
export const listMyCommonAreaCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/commonAreaCleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listMyCommonAreaCleanings.method = "GET" as const;

/**
 * 清掃員が物件の情報を取得する
 * 
 */
export const findListingByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/listing`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingByCleaningId.method = "GET" as const;

/**
 * 清掃員がリスティングに紐づくトラブルの一覧を取得する
 * 
 */
export const listTroublesByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/listings/${listingId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTroublesByListingId.method = "GET" as const;

/**
 * 清掃員が清掃の写真ツアーを取得する
 * 
 */
export const findPhotoTourByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/photo_tour`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourByCleaningId.method = "GET" as const;

/**
 * 清掃員が写真ツアー画像をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issuePhotoTourImageUploadUrl = ({cleaningId, photoTourItemId}: {cleaningId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/items/${photoTourItemId}/upload/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issuePhotoTourImageUploadUrl.method = "POST" as const;

/**
 * 清掃員が写真ツアー画像のS3直接アップロード完了を通知する
 * 
 */
export const completePhotoTourImageUpload = ({cleaningId, photoTourItemId}: {cleaningId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/items/${photoTourItemId}/upload/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completePhotoTourImageUpload.method = "POST" as const;

/**
 * 清掃員が写真ツアーの写真を更新する
 * 
 */
export const photoTourImage = ({imageId}: {imageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/photoTourImage/${imageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
photoTourImage.method = "PUT" as const;

/**
 * 清掃員が写真ツアーの動画を更新する
 * 
 */
export const photoTourVideo = ({movieId}: {movieId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/photoTourMovie/${movieId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
photoTourVideo.method = "PUT" as const;

/**
 * 清掃員が清掃を開始する
 * 
 */
export const startCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/cleanings/${cleaningId}/start`;
    return __queries ? `${__path}?${__queries}` : __path;
};
startCleaning.method = "POST" as const;

/**
 * 清掃員が清掃を終了する
 * 
 */
export const finishCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/cleanings/${cleaningId}/finish`;
    return __queries ? `${__path}?${__queries}` : __path;
};
finishCleaning.method = "POST" as const;

/**
 * 清掃報告を完了する
 * 
 */
export const reportCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/cleanings/${cleaningId}/report`;
    return __queries ? `${__path}?${__queries}` : __path;
};
reportCleaning.method = "POST" as const;

/**
 * お願い事写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueErrandPictureUploadUrl = ({errandId}: {errandId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/errands/${errandId}/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueErrandPictureUploadUrl.method = "POST" as const;

/**
 * お願い事写真のS3直接アップロード完了を通知する
 * 
 */
export const completeErrandPictureUpload = ({errandId}: {errandId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/errands/${errandId}/picture/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeErrandPictureUpload.method = "POST" as const;

/**
 * 清掃員が清掃の詳細情報を取得する
 * 
 */
export const getCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaning.method = "GET" as const;

/**
 * 清掃員が清掃に紐付いたタスクの一覧を取得する
 * 
 */
export const listCleaningTasks = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/tasks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaningTasks.method = "GET" as const;

/**
 * 清掃員がタスク写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueTaskPictureUploadUrl = ({cleaningId, taskId}: {cleaningId: string, taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/tasks/${taskId}/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueTaskPictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がタスク写真のS3直接アップロード完了を通知する
 * 
 */
export const completeTaskPictureUpload = ({cleaningId, taskId}: {cleaningId: string, taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/tasks/${taskId}/picture/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeTaskPictureUpload.method = "POST" as const;

/**
 * 清掃員が清掃のチェックリストを取得する
 * 
 */
export const getCheckitems = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/checkitems`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCheckitems.method = "GET" as const;

/**
 * 清掃員が新しいトラブルを送信する
 * 
 */
export const sendProblems = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sendProblems.method = "POST" as const;

/**
 * 清掃員がトラブル写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueTroublePictureUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/troubles/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueTroublePictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がアップロード済み写真を紐づけて新しいトラブルを作成する
 * 
 */
export const createTroubleWithUploadedPictures = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/troubles/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createTroubleWithUploadedPictures.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueEvidenceUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/evidence/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueEvidenceUploadUrl.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真のS3直接アップロード完了を通知する
 * 
 */
export const completeEvidenceUpload = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/evidence/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeEvidenceUpload.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真を削除する
 * 
 */
export const deleteEvidencePicture = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/evidence`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteEvidencePicture.method = "DELETE" as const;

/**
 * 清掃員がキーボックスの鍵番号を取得する
 * 
 */
export const getKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/keybox`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getKeyboxNumber.method = "GET" as const;

/**
 * 清掃員がキーボックス写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueKeyboxPictureUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/keybox/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueKeyboxPictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がキーボックスの鍵を変更する（S3直接アップロード後の完了通知）
 * 
 */
export const completeKeyboxRotation = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/keybox/rotate/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeKeyboxRotation.method = "POST" as const;

/**
 * 清掃員がキーボックスの鍵を変更する
 * 
 */
export const rotateKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v2/mypage/cleanings/${cleaningId}/keybox/rotate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rotateKeyboxNumber.method = "POST" as const;
export const m2mCleaning_cleanerV2 = {listMyCleanings,listMyCommonAreaCleanings,findListingByCleaningId,listTroublesByListingId,findPhotoTourByCleaningId,issuePhotoTourImageUploadUrl,completePhotoTourImageUpload,photoTourImage,photoTourVideo,startCleaning,finishCleaning,reportCleaning,issueErrandPictureUploadUrl,completeErrandPictureUpload,getCleaning,listCleaningTasks,issueTaskPictureUploadUrl,completeTaskPictureUpload,getCheckitems,sendProblems,issueTroublePictureUploadUrl,createTroubleWithUploadedPictures,issueEvidenceUploadUrl,completeEvidenceUpload,deleteEvidencePicture,getKeyboxNumber,issueKeyboxPictureUploadUrl,completeKeyboxRotation,rotateKeyboxNumber};
